import App from "./App.svelte";
import checkEventData from "./js/checkEventData.js";
import props from "./content/data.json";

let resizeData = {};
let app;
/* Add 20px padding to the document to account for the scrollbar which 
   might be present within the iframe depending on browser / mouse combinations */
let extraHeight = 20;

function sendResizeMessage() {
  let documentHeight = document.querySelector("body").offsetHeight;
  window.parent.postMessage(
    { height: documentHeight + extraHeight, requestData: resizeData },
    "*"
  );

  console.log("sendResizeMessage:", {
    height: documentHeight + extraHeight,
    resizeData,
  });

  return null;
}

function handleMessage(event) {
  console.log("handleMessage");
  console.log(event);
  let goodEvent = checkEventData(event);
  if (goodEvent) {
    let { data } = event;
    let { articleId } = data;
    resizeData = { ...data };
    sendResizeMessage();
    app.$set({ articleId });
  }

  return null;
}

function init() {
  app = new App({
    target: document.querySelector("#server-rendered-html"),
    props: { ...props },
    hydrate: true,
  });

  app.$on("update", () => {
    sendResizeMessage();
  });
}

window.addEventListener("message", handleMessage);
window.addEventListener("resize", sendResizeMessage);
document.addEventListener("DOMContentLoaded", init);

export default app;
